export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7571.52549d87.jpg";